import { hasNonDigitCharacters, getSumOfMultiplcicationResults } from '../helpers/index.js';

/**
 * ИНН которые валидны алгоритмически, но по факту нет
 */

var innExcepts = ['0000000000'];
var validLegalInn = function validLegalInn(_a) {
  var _b = _a === void 0 ? {} : _a,
    _c = _b.message,
    message = _c === void 0 ? 'Введите корректный ИНН' : _c,
    _d = _b.invalidLengthMessage,
    invalidLengthMessage = _d === void 0 ? 'ИНН юридического лица состоит из 10 цифр' : _d,
    _e = _b.invalidCharactersMessage,
    invalidCharactersMessage = _e === void 0 ? 'ИНН может соcтоять только из цифр' : _e;
  return function (value) {
    if (!value || !value.trim()) {
      return message;
    }
    if (hasNonDigitCharacters(value)) {
      return invalidCharactersMessage;
    }
    if (value.length !== 10) {
      return invalidLengthMessage;
    }
    if (innExcepts.includes(value)) {
      return message;
    }
    var digits = value.split('');
    var numbers = digits.slice(0, 9);
    var code = digits[9];
    var coefficients = [2, 4, 10, 3, 5, 9, 4, 6, 8];
    var controlSum = getSumOfMultiplcicationResults(numbers, coefficients) % 11;
    var controlSumLeastSignificantDigit = controlSum % 10;
    if (controlSumLeastSignificantDigit !== Number.parseInt(code, 10)) {
      return message;
    }
    return;
  };
};
export default validLegalInn;
export { validLegalInn };